import React from "react";
import Weather from "./Weather";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Fairfax" />
        <footer>
          This project was coded by Lilia Gashin and is
          <br />
          <a
            href="https://github.com/codinglil/weather-react2"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
